document.addEventListener('variant:change', function(evt) {
  console.log(evt.detail.variant);
// update price in button
});

// cart-add-item.js
(function() {
  var CartAddItem = {
    selectors: {
      addItemButton: '.js-add-item',
      cartContainer: '#CartDrawer'
    },

    classes: {
      btnLoading: 'btn--loading'
    },

    init: function() {
      this.setupEventListeners();
    },

    setupEventListeners: function() {
      document.body.addEventListener('click', this.handleAddItemClick.bind(this));
    },

    handleAddItemClick: function(evt) {
      var addItemButton = evt.target.closest(this.selectors.addItemButton);
      if (!addItemButton) return;

      evt.preventDefault();

      var variantId = addItemButton.getAttribute('data-variant-id');
      var quantity = 1;

      addItemButton.classList.add(this.classes.btnLoading);
      document.querySelector(this.selectors.cartContainer).classList.add('is-loading');

      this.addItemToCart(variantId, quantity, addItemButton);
    },

    addItemToCart: function(variantId, quantity, button) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        // Trigger cart build event
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        button.classList.remove(this.classes.btnLoading);
        document.querySelector(this.selectors.cartContainer).classList.remove('is-loading');
      });
    },

    updateCart: function() {
      if (window.theme && window.theme.cart && window.theme.cart.getCartProductMarkup) {
        window.theme.cart.getCartProductMarkup().then(function(text) {
          var cartForm = document.querySelector('form[action="/cart"]');
          if (cartForm && cartForm.dataset && cartForm.dataset.cartForm) {
            var cartFormObject = JSON.parse(cartForm.dataset.cartForm);
            if (cartFormObject && cartFormObject.cartMarkup) {
              cartFormObject.cartMarkup(text);
            }
          }
        });
      }
    }
  };

  // Initialize the CartAddItem functionality
  document.addEventListener('DOMContentLoaded', function() {
    CartAddItem.init();
  });
})();